import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { ColumnChooserModel } from '../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../models/common/ColumnFilterModel';

/**
 * Genel Giderler > HGS Kayıtları (26.10.2026, #100 / #101 / #488). İşlem tarihi = GİRİŞ zamanı. İşlem türü Geçiş / Yükleme / İade / Düzeltme;
 * maliyete yalnız Geçiş (+), İade (−), Düzeltme (işaretli) girer. TL karşılığı işlem tarihinin döviz alış kuruyla.
 */

export const HGS_SAYFASI = 'Genel Giderler > HGS Kayıtları';

export const ISLEM_TURU = { GECIS: 1, YUKLEME: 2, IADE: 3, DUZELTME: 4 };

export interface HgsListIstegi {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    columnChooser: ColumnChooserModel[] | undefined
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
    ids?: string[]
}

export const ilkHgsListIstegi: HgsListIstegi = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    columnFilters: []
}

export interface HgsKaydi {
    hgsOgsKaydiId: string
    islemTuru: number
    islemTuruAdi: string
    etiketNo?: string
    hamPlaka?: string
    kaynakAdi: string
    eslesmeDurumuAdi: string
    maliyetTL: number
    vehicleId: string
    plaka?: string
    aracCinsi?: string
    islemTarihiStr: string
    islemTarihiDeger: string
    islemSaati?: string
    girisYeri?: string
    cikisTarihiStr?: string
    cikisTarihiDeger?: string
    cikisSaati?: string
    cikisYeri?: string
    isletmeId?: string
    isletme?: string
    gecisTuruId?: string
    gecisTuru?: string
    tutar: number
    currencyTypeId: string
    dovizCinsi?: string
    kur: number
    tutarTL: number
    seferModuluAdi?: string
    seferId?: string
    seferNo?: string
    aciklama?: string
    isSelected?: boolean
}

/** Dip toplamlar: filtrelenmiş bütün satırlar (sayfaya bağlı değil). */
export interface HgsToplamlari {
    tutar?: number
    dovizCinsi?: string
    farkliDoviz: boolean
    tutarTL: number
    maliyetTL: number
}

export interface HgsKaydet {
    id?: string
    islemTuru: number
    vehicleId?: string
    islemTarihi?: string
    islemSaati?: string
    girisYeri?: string
    cikisTarihi?: string
    cikisSaati?: string
    cikisYeri?: string
    isletmeId?: string
    gecisTuruId?: string
    tutar?: number
    currencyTypeId?: string
    seferId?: string
    etiketNo?: string
    aciklama?: string
}

export interface HgsSecenek { value: string, label: string, ek?: string }

export interface HgsSecenekleri {
    islemTurleri: { value: number, label: string }[]
    gecisTurleri: HgsSecenek[]
    /** Otoyol işletmeleri; ek = bankanın kodu (KCO, GOI ...). */
    isletmeler: HgsSecenek[]
    dovizCinsleri: HgsSecenek[]
    varsayilanDovizId?: string
    /** Olduğu gibi yüklenebilen banka / PTT dökümleri (ör. "Ziraat Bankası"). */
    taninanDokumler: string[]
}

export interface HgsExcelSatiri {
    /** Birden çok dosya yüklendiğinde satırın dosyası. */
    dosya?: string
    satirNo: number
    islemTuru?: string
    plaka?: string
    etiketNo?: string
    islemTarihi?: string
    islemSaati?: string
    girisYeri?: string
    cikis?: string
    cikisYeri?: string
    isletme?: string
    gecisTuru?: string
    tutar?: number
    dovizCinsi?: string
    seferNo?: string
    aciklama?: string
    tutarTL?: number
    hatalar: string[]
    mukerrer: boolean
}

export interface HgsExcelSonucu {
    satirSayisi: number
    hataliSatir: number
    mukerrerSatir: number
    ornekSatirAtlandi: boolean
    /** Banka dökümünde atlanan sıfır tutarlı, gişesiz satırlar (gerçek geçiş değil). */
    atlananSifirSatir: number
    toplamTL: number
    satirlar: HgsExcelSatiri[]
    hata?: string
    ayniDosyaUyarisi?: string
    aktarilan: number
    dosyalar: { ad: string, bicim: string, satirSayisi: number, atlananSifirSatir: number }[]
}

/** "1.234,56"; boşsa "—". */
export const tutarYaz = (n: number | null | undefined) => n == null ? '—' : n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const cagir = async (yol: string, inputObj: any) => {
    try {
        console.log('SERVICE CALL - HgsOgs/' + yol, JSON.stringify(inputObj));

        const resp = await axios.post(Helpers.getEndpoint() + '/HgsOgs/' + yol, inputObj);

        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

const dosyaGonder = async (yol: string, dosyalar: File[]) => {
    try {
        const form = new FormData();
        dosyalar.forEach(d => form.append('dosyalar', d));

        const resp = await axios.post(Helpers.getEndpoint() + '/HgsOgs/' + yol, form, { headers: { 'Content-Type': 'multipart/form-data' } });

        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class HgsOgsService {
    static getList(inputObj: HgsListIstegi) { return cagir('GetListPagingAndFilter', inputObj); }
    static exportList(inputObj: HgsListIstegi) { return cagir('ExportList', inputObj); }
    static getById(id: string) { return cagir('GetById', { id }); }
    static kaydet(inputObj: HgsKaydet) { return cagir('Kaydet', inputObj); }
    static sil(ids: string[]) { return cagir('Sil', { ids }); }
    static secenekler() { return cagir('Secenekler', {}); }
    static plakalar() { return cagir('Plakalar', {}); }
    static seferler(vehicleId?: string, arama?: string) { return cagir('Seferler', { vehicleId, arama }); }
    static ornekExcel() { return cagir('OrnekExcel', {}); }
    /** Keylogx şablonu ya da Ziraat Bankası HGS dökümü; birden çok dosya (her araç için ayrı döküm) seçilebilir. */
    static excelOnizle(dosyalar: File[]) { return dosyaGonder('ExcelOnizle', dosyalar); }
    static excelAktar(dosyalar: File[]) { return dosyaGonder('ExcelAktar', dosyalar); }
}
